import TopHeader from "../../components/topHeader/TopHeader";
import MarketSettings from "../../components/admin/marketSettings/MarketSettings";
import { BaseButton } from "../../components/base";
import { useNavigate } from "react-router-dom";
import URIs from "../../utils/uri";
import { useTheme, Typography } from "@mui/material";

const AdminDashboard = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    return (
        <div>
            <TopHeader>
                <BaseButton
                    sx={{
                        width: "40%",
                        marginLeft: "10px",
                        height: "30px",
                        background: theme.palette.primary.default
                    }}
                    onClick={() => navigate(URIs.HOME)}
                >
                    <Typography
                        variant="caption2"
                    >
                        برو به پنل کاربران
                    </Typography>
                </BaseButton>
            </TopHeader>
            <MarketSettings/>
        </div>
    )
}
export default AdminDashboard;